import type {z} from "zod";

import {AddRepresentativeCommissionBody} from "@project/sdk/sales/zod";

import {requiredStringSchema} from "../../../../../../../shared/validation/required-string.schema";
import {commissionFieldLabelIds} from "../../../../../messages/representative-commission.messages";

export const addRepresentativeCommissionNameSchema = requiredStringSchema(
  AddRepresentativeCommissionBody.shape.name,
  commissionFieldLabelIds.name,
);
export const addRepresentativeCommissionPercentageSchema =
  AddRepresentativeCommissionBody.shape.percentage;

export const addRepresentativeCommissionFormSchema = AddRepresentativeCommissionBody.extend({
  name: addRepresentativeCommissionNameSchema,
});
export type AddRepresentativeCommissionFormPayload = z.output<
  typeof addRepresentativeCommissionFormSchema
>;

export const draftAddRepresentativeCommissionFormSchema =
  addRepresentativeCommissionFormSchema.partial();
export type DraftAddRepresentativeCommissionFormPayload = z.output<
  typeof draftAddRepresentativeCommissionFormSchema
>;
